import {CARD_LOGOS} from '../consts';

export const getCardLogoUrl = card => {
    const cardType = card?.displayData?.cardType?.toLowerCase();

    return CARD_LOGOS[cardType] || CARD_LOGOS.cybersourceOther;
};
